'use strict';

const config = {
  appEnv: 'dev',
  apiUrl: 'http://10.131.11.194:8089/graphql',
  authApiUrl: 'https://stage-access.epsilon.com/be/auth/auth',
  tokenApiTUrl: 'https://stage-access.epsilon.com/be/auth/auth/token',
  loginOptions: {
    validationUrl: 'https://stage-access.epsilon.com',
    ssoPage: '/auth/sso.html',
    loginPage: '/auth/login',
    params: {
      product: 'ccui',
      generateCode: true
    },
    stage: true
  }
};

export default config;



// WEBPACK FOOTER //
// ./src/config/dev.js